module.exports = __webpack_public_path__ + "img/gd-right-top.938bc6ad.svg";